import $ from "jquery";

export const manageProductGridGallery = () => {
  const productGridSelector = ".catifa-product-grid";
  const productGridGalleryItemsSelector = ".product-grid__item";
  const productGridGallerySelector = ".product-grid-gallery";
  const productGridGalleryItemsSliderSelector = ".product-grid-gallery__items";
  const productGridGalleryCloseSelector = ".product-grid-gallery__close";
  const productGridGalleryActiveClass = "product-grid-gallery--active";
  const productGridGalleryReadyClass = "product-grid-gallery--ready";
  const productGridGalleryPrevSelector =
    productGridGallerySelector + " .image-gallery__slider__arrow-prev";
  const productGridGalleryNextSelector =
    productGridGallerySelector + " .image-gallery__slider__arrow-next";

  const grid = document.querySelector<HTMLDivElement>(productGridSelector);
  const gallery = document.querySelector<HTMLDivElement>(
    productGridGallerySelector,
  );
  const slider = gallery?.querySelector(productGridGalleryItemsSliderSelector);

  if (!grid || !gallery || !slider) {
    return;
  }

  const $slickInstance = $(slider);
  const $slickPrev = $(productGridGalleryPrevSelector);
  const $slickNext = $(productGridGalleryNextSelector);

  const closeGalleryOnEscape = (e: KeyboardEvent) => {
    // Close gallery on escape key press
    if (e.key === "Escape") {
      closeGallery();
    }
  };

  const onCloseClick = (e: Event) => {
    e.preventDefault();
    closeGallery();
  };

  // close the gallery by placing it over the grid item and then disappearing
  const closeGallery = () => {
    // number of items inside the grid is != from number of items inside the slider (we don't show the 3D model)
    const currentSlideIndex = $slickInstance.slick("slickCurrentSlide");
    const originalGallerySlide = gallery
      .querySelector(productGridGalleryItemsSliderSelector)!
      .querySelector<HTMLDivElement>(
        `.slick-slide:nth-child(${currentSlideIndex + 1}) [data-grid-index]`,
      );
    const gridIndex = parseInt(
      originalGallerySlide?.dataset?.["gridIndex"] ?? "NaN",
    );

    const startingPoint = grid
      .querySelector(`[data-grid-index="${gridIndex}"]`)
      ?.getBoundingClientRect();
    if (!startingPoint) {
      return;
    }

    overlapGalleryToGridItem(startingPoint);
    gallery.classList.remove(productGridGalleryActiveClass);
    gallery.classList.remove(productGridGalleryReadyClass);
  };

  const setSliderCurrentSlide = (gridIndex: number) => {
    // number of items inside the grid is != from number of items inside the slider (we don't show the 3D model)
    const galleryItem = gallery.querySelector(
      `[data-grid-index="${gridIndex}"]`,
    )!;
    const slickSlideItem = galleryItem.parentNode!.parentNode!; // we want to break if this is undefined.
    const sliderIndex = Array.from(
      slickSlideItem.parentNode?.children ?? [],
    ).indexOf(slickSlideItem as Element);
    $slickInstance.slick("slickGoTo", sliderIndex, true);
    gallery.classList.add(productGridGalleryReadyClass);
  };

  // Make gallery appear from the clicked item position
  const showGalleryAppearingFrom = (itemPositionInGallery: DOMRect) => {
    overlapGalleryToGridItem(itemPositionInGallery);

    gallery.classList.add("transition-all", productGridGalleryActiveClass);
    return makeGalleryFullscreen();
  };

  const overlapGalleryToGridItem = (startingPoint: DOMRect) => {
    gallery.style.top = startingPoint.top + "px";
    gallery.style.bottom = window.innerHeight - startingPoint.bottom + "px";
    gallery.style.left = startingPoint.left + "px";
    gallery.style.right =
      document.body.offsetWidth - startingPoint.right + "px";
  };

  const makeGalleryFullscreen = () => {
    return new Promise<void>((resolve) => {
      // make others know that we resized
      setTimeout(() => {
        gallery.style.top = 0 + "px";
        gallery.style.bottom = 0 + "px";
        gallery.style.left = 0 + "px";
        gallery.style.right = 0 + "px";
        setTimeout(resolve, 150); // wait for the transition to finish
      }, 50); // wait for DOM to read the new transition class
    });
  };

  const onGridItemClick = (item: HTMLDivElement) => {
    // number of items inside the grid is != from number of items inside the slider (we don't show the 3D model)
    const gridIndex = parseInt(item.dataset["gridIndex"] ?? "NaN");

    if (isNaN(gridIndex)) {
      return;
    }

    const startingPoint = item.getBoundingClientRect();
    showGalleryAppearingFrom(startingPoint).then(() => {
      setSliderCurrentSlide(gridIndex);
    });
  };

  const init = (pageWidth: number) => {
    const isMd = pageWidth > 990; // custom tailwind breakpoint
    if ($(productGridSelector).hasClass("slick-initialized")) {
      $(productGridSelector).slick("unslick");
    }

    if ($slickInstance.hasClass("slick-initialized")) {
      $slickInstance.slick("unslick");
    }
    if (!isMd) {
      // show a simple image slider
      $(productGridSelector).slick({
        dots: true,
        arrows: false,
        infinite: false,
        autoplay: false,
        speed: 300,
        slidesToShow: 1.25,
        slidesToScroll: 1,
        variableWidth: true,
        mobileFirst: true,
      });
    }

    // apply slick carousel to image gallery
    $slickInstance.slick({
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      prevArrow: $slickPrev,
      nextArrow: $slickNext,
    });

    document
      .querySelector(productGridGalleryCloseSelector)
      ?.removeEventListener("click", onCloseClick);
    document
      .querySelector(productGridGalleryCloseSelector)
      ?.addEventListener("click", onCloseClick);

    window.removeEventListener("keyup", closeGalleryOnEscape);
    window.addEventListener("keyup", closeGalleryOnEscape);

    grid
      .querySelectorAll<HTMLDivElement>(productGridGalleryItemsSelector)
      .forEach((item) => {
        const onItemClick = (event: MouseEvent) => {
          event.preventDefault();
          onGridItemClick(item);
        };
        item.removeEventListener("click", onItemClick);
        item.addEventListener("click", onItemClick);
      });
  };

  window.addEventListener("resize", () => {
    init(document.body.offsetWidth);
  });
  init(document.body.offsetWidth);
};
